import { useState } from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { Container } from "~/components/layout/Container";
import {
  CalendarIcon,
  FingerprintIcon,
  SearchIcon,
  ShieldCheckIcon,
} from "~/components/common/icons";

export const HomeHero = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [query, setQuery] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(
      query.trim()
        ? `/merchants?q=${encodeURIComponent(query.trim())}`
        : "/merchants",
    );
  };

  const trustPoints = [
    {
      icon: <FingerprintIcon className="h-4 w-4" />,
      label: t("HomePage.trust-identity"),
    },
    {
      icon: <ShieldCheckIcon className="h-4 w-4" />,
      label: t("HomePage.trust-credentials"),
    },
    {
      icon: <CalendarIcon className="h-4 w-4" />,
      label: t("HomePage.trust-booking"),
    },
  ];

  return (
    <section className="relative overflow-hidden bg-surface-sari">
      <div
        className="hero-glow pointer-events-none absolute inset-0"
        aria-hidden="true"
      />
      <Container>
        <div className="relative mx-auto max-w-3xl px-2 py-24 text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-raytio-poolblue/25 bg-raytio-poolblue/10 px-4 py-1.5 text-sm font-medium text-raytio-poolblue-text dark:text-raytio-poolblue">
            <ShieldCheckIcon className="h-4 w-4" />
            {t("HomePage.badge")}
          </span>

          <h1 className="mt-8 font-heading text-5xl font-extrabold uppercase leading-[1.05] tracking-tight text-text-full sm:text-6xl md:text-7xl">
            <span className="block">{t("HomePage.title-line1")}</span>
            <span className="block">{t("HomePage.title-line2")}</span>
          </h1>

          <p className="mx-auto mt-6 max-w-2xl text-lg text-text-medium">
            {t("HomePage.subtitle")}
          </p>

          <form
            onSubmit={handleSubmit}
            className="mx-auto mt-8 flex max-w-2xl items-center gap-2 rounded-full border border-border-shell bg-surface-blank p-1.5 pl-5 shadow-simple"
          >
            <SearchIcon className="h-5 w-5 shrink-0 text-text-light" />
            <input
              type="search"
              value={query}
              onChange={e => setQuery(e.target.value)}
              placeholder={t("HomePage.search-placeholder")}
              className="min-w-0 flex-1 bg-transparent py-2 font-body text-text-full placeholder-text-light focus:outline-none"
            />
            <button
              type="submit"
              className="shrink-0 rounded-full bg-accent px-6 py-2.5 font-heading text-sm font-semibold uppercase tracking-wider text-ink transition hover:brightness-95"
            >
              {t("HomePage.search-button")}
            </button>
          </form>

          <div className="mt-6 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm text-text-medium">
            {trustPoints.map(point => (
              <span
                key={point.label}
                className="inline-flex items-center gap-2"
              >
                <span className="text-raytio-poolblue-text dark:text-raytio-poolblue">
                  {point.icon}
                </span>
                {point.label}
              </span>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
};
